/* Fransk katalog for locale-vat-purchases-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'vat.term': 'Période de TVA',
  'vat.termHelp': 'Une période de TVA est la période pour laquelle vous déclarez la taxe sur la valeur ajoutée. La plupart déclarent tous les deux mois - 6 périodes par an. Pour chaque période, la TVA collectée et la TVA déductible sont totalisées, et la différence est payée à l\'État ou remboursée par celui-ci.',
  'vat.termShort': 'période',
  'vat.deadline': 'ÉCHÉANCE',
  'vat.amountHelp': 'TVA à payer signifie que vous devez de l\'argent à l\'État parce que la TVA collectée dépassait la TVA déductible. Crédit de TVA signifie que vous récupérez de l\'argent parce que vous avez payé plus de TVA sur vos achats que vous n\'en avez collecté sur vos ventes.',
  'vat.openReturn': 'Ouvrir la déclaration',
  'vat.sortHelp': 'Les périodes sont triées par statut : « Action requise » doit être déclarée maintenant, « À venir » correspond aux périodes futures et « Antérieures » sont déjà déclarées ou payées.',
  'vat.noTerms': 'Aucune période de TVA pour l\'instant',
  'vat.incompleteBasisTitle': 'La base de TVA est incomplète',
  'vat.incompleteBasisText': 'La MVA-melding n\'est pas présentée comme complète, car la couverture du journal n\'est pas documentée. Les calculs à partir des documents restent utilisables à des fins de diagnostic, mais pas comme base comptable complète.',
  'vat.needsAction': 'Action requise',
  'vat.upcoming': 'À venir',
  'vat.earlier': 'Antérieures',
  'vat.toPay': 'TVA à payer',
  'vat.toPayHelp': 'Total de la TVA restant due lorsque la TVA collectée dépasse la TVA déductible.',
  'vat.paidIn': 'Payé',
  'vat.paidInHelp': 'Paiements de TVA que vous avez enregistrés sur des périodes dans Plumme.',
  'vat.refunded': 'Remboursé',
  'vat.refundedHelp': 'Remboursements de TVA que vous avez enregistrés sur des périodes dans Plumme.',
  'vat.perTerm': 'Par période',
  'vat.returnStatus': 'Statut de la MVA-melding',
  'vat.period': 'Période',
  'vat.due': 'Échéance',
  'vat.calculated': 'Règlement calculé',
  'vat.settlement': 'Règlement',
  'vat.cancelPayment': 'Annuler le paiement',
  'vat.date': 'Date',
  'vat.amount': 'Montant',
  'vat.reference': 'Référence',
  'vat.referencePh': 'Ex. : banque en ligne, OCR',
  'vat.payments': 'Paiements',
  'vat.paymentsHelp': 'Aperçu des paiements enregistrés sur cette période de TVA.',
  'vat.noPayments': 'Aucun paiement enregistré',
  'vat.fromAccount': 'Depuis le compte',
  'vat.edit': 'Modifier',
  'vat.cancel': 'Annuler',
  'vat.cancelPaymentTitle': 'Annuler le paiement ?',
  'vat.cancelPaymentConfirm': 'Oui, annuler le paiement',
  'vat.backToTerms': 'Retour aux périodes',
  'vat.importedBasisTitle': 'Importé depuis un autre logiciel comptable',
  'vat.importedBasisHelp': 'Les chiffres ont été importés comme base. Vous pouvez créer, déposer et, si nécessaire, annuler la MVA-melding via le processus habituel.',
  'vat.outputVat': 'TVA collectée',
  'vat.outputVatHelp': 'TVA que vous avez collectée sur les ventes de la période.',
  'vat.inputVat': 'TVA déductible',
  'vat.inputVatHelp': 'TVA déductible que vous avez payée sur les achats de la période.',
  'vat.netVat': 'TVA nette',
  'vat.netHelp': 'TVA collectée moins TVA déductible. Un montant positif est à payer, un montant négatif est un crédit.',
  'vat.checkStatus': 'Vérifier le statut',
  'vat.checkStatusHelp': 'Affiche le statut de la MVA-melding enregistré dans Plumme. Le statut automatique depuis Altinn ou Skatteetaten n\'est pas encore connecté dans cet espace Plumme.',
  'vat.seePayment': 'Voir le paiement',
  'vat.seePaymentHelp': 'Consultez les paiements enregistrés sur cette période de TVA — date, compte, montant et référence.',
  'vat.codeOverview': 'Récapitulatif des codes pour le dépôt',
  'vat.codeOverviewHelp': 'La MVA-melding est constituée de codes TVA standardisés de Skatteetaten. Chaque code regroupe un type précis de vente ou d\'achat. La base est le montant hors TVA. En cas d\'autoliquidation, la TVA collectée et la TVA déductible apparaissent toutes deux, même lorsque le montant net est nul. Appuyez sur un code pour voir ce qui y figure.',
  'vat.codeTapHint': 'Appuyez sur un code pour voir ce qui y figure.',
  'vat.code': 'Code',
  'vat.description': 'Description',
  'vat.basis': 'Base',
  'vat.rate': 'Taux',
  'vat.vat': 'TVA',
  'vat.calculatedFrom': 'Calculé à partir de ce que vous avez enregistré dans l\'application',
  'vat.delete': 'Supprimer',
  'vat.annulCustoms': 'Annuler',
  'vat.annulled': 'Annulé',
  'vat.showAnnulledCustoms': 'Afficher les annulées',
  'vat.showActiveCustoms': 'Afficher les actives',
  'vat.customsAnnulled': 'Déclaration en douane annulée',
  'vat.customsAnnulFailed': 'Impossible d\'annuler la déclaration en douane.',
  'vat.registerCustoms': 'Enregistrer une déclaration en douane',
  'vat.customsHelp': 'Saisissez une déclaration en douane pour les marchandises que vous avez importées de l\'étranger. Plumme calcule la TVA à l\'importation à partir de la valeur statistique et l\'inscrit sous le bon code dans la déclaration.',
  'vat.flowHelp': 'Vérifiez les chiffres issus des justificatifs comptabilisés. Plumme ne peut pas envoyer la MVA-melding : vous la déposez dans le service de Skatteetaten, puis marquez ici la période comme déposée hors de Plumme. Vous pouvez alors enregistrer le paiement. Le statut « déposé » peut être retiré s\'il a été défini par erreur.',
  'vat.filing.statusFiled': 'Déposée hors de Plumme',
  'vat.filing.statusFiledPaid': 'Déposée hors de Plumme et payée',
  'vat.filing.statusNotFiled': 'Non marquée comme déposée',
  'vat.filing.reviewFigures': 'Vérifier les chiffres',
  'vat.filing.reviewedToast': 'Les chiffres sont vérifiés. Déposez la MVA-melding auprès de Skatteetaten.',
  'vat.filing.markOutside': 'Marquer comme déposée hors de Plumme',
  'vat.filing.clearStatus': 'Retirer le statut « déposé »',
  'vat.filing.dialogTitle': 'Déposer la MVA-melding auprès de Skatteetaten',
  'vat.filing.cannotSend': 'Plumme ne peut ni envoyer ni signer la MVA-melding. Vous la déposez vous-même auprès de Skatteetaten, puis marquez ici la période comme déposée.',
  'vat.filing.step1': 'Ouvrez la MVA-melding dans le service de Skatteetaten et saisissez les chiffres de cette période depuis Plumme.',
  'vat.filing.step2': 'Envoyez et signez la déclaration sur place, et conservez le reçu.',
  'vat.filing.step3': 'Marquez ici la période comme déposée hors de Plumme. Vous pourrez alors enregistrer le paiement, et la période comptera comme déposée lors de la clôture annuelle.',
  'vat.filing.termNotEnded': 'La période n\'est pas encore terminée. La MVA-melding ne peut être déposée qu\'après la fin de la période.',
  'vat.filing.filedDate': 'Date de dépôt',
  'vat.filing.reference': 'Référence (facultatif)',
  'vat.filing.referencePh': 'Par exemple la référence figurant sur le reçu de Skatteetaten',
  'vat.filing.comment': 'Commentaire (facultatif)',
  'vat.filing.lockNote': 'Une fois la période marquée comme déposée, les justificatifs de la période sont verrouillés. Toute modification doit alors se faire par une correction.',
  'vat.filing.clearText': 'La période apparaîtra alors comme non déposée dans Plumme et ses justificatifs seront déverrouillés. La modification est journalisée avec l\'auteur et la date. Le statut auprès de Skatteetaten ne change pas.',
  'vat.filing.clearReason': 'Motif (facultatif)',
  'vat.filing.markedToast': 'La période est marquée comme déposée hors de Plumme',
  'vat.filing.clearedToast': 'Statut « déposé » retiré',
  'vat.filing.failed': 'Impossible de mettre à jour le statut de TVA.',
  'vat.filing.payAfterFiled': 'Disponible une fois la MVA-melding déposée auprès de Skatteetaten et marquée ici comme déposée.',
  'vat.filing.markedOn': 'Marqué dans Plumme',
  'vat.filing.referenceLabel': 'Référence',
  'vat.filing.commentLabel': 'Commentaire',
  'vat.filing.statusNote': 'Plumme ne récupère pas le statut auprès de Skatteetaten. Le statut affiché ici est celui marqué dans Plumme.',
  'vat.addComment': 'Ajouter un commentaire',
  'vat.customs': 'Déclaration en douane',
  'vat.correctCustoms': 'Corriger la déclaration en douane',
  'vat.saveCustoms': 'Enregistrer la déclaration en douane',
  'vat.fetchFromAltinn': 'Récupérer depuis Altinn',
  'vat.fetchFromAltinnHelp': 'Remplissez automatiquement la référence et la valeur en douane à partir des déclarations déposées.',
  'vat.declarationRef': 'Référence de la déclaration',
  'vat.declarationRefPh': 'Référence de Tolletaten',
  'vat.statisticalValue': 'Valeur statistique',
  'vat.vatCode': 'Code TVA',
  'vat.attachments': 'Pièces jointes / traçabilité de l\'import',
  'vat.uploadAttachment': 'Téléverser une pièce jointe',
  'vat.attachmentHelp': 'Facultatif, mais recommandé pour la piste d\'audit et le suivi ultérieur de l\'import.',
  'vat.customsBasis': 'Valeur en douane',
  'vat.calculatedVat': 'TVA calculée',
  'vat.deductible': 'Droit à déduction',
  'vat.settlementDate': 'Date de règlement',
  'vat.settlementType': 'Type de règlement',
  'vat.useDueDate': 'Date d\'échéance',
  'vat.useDueDateHelp': 'Définir la date de règlement sur la date d\'échéance de la MVA-melding',
  'vat.addSurcharges': 'Ajouter intérêts/frais',
  'vat.surcharges': 'Intérêts et frais',
  'vat.removeSurcharges': 'Retirer',
  'vat.lateInterest': 'Intérêts de retard',
  'vat.lateInterestHelp': 'Comptabilisés en charge d\'intérêts sur le compte 8150',
  'vat.penaltyFee': 'Frais ou astreinte',
  'vat.penaltyFeeHelp': 'Comptabilisé sur le compte 7799 et non déductible',
  'vat.surchargeTotal': 'Débité du compte',
  'vat.surchargeNote': 'Les intérêts et frais ne sont pas de la TVA. Ils sont passés en charges et débités du compte, mais ne modifient pas le règlement de TVA de la période.',
  'vat.kid': 'KID',
  'vat.payTitle': 'Payer la TVA à Skatteetaten',
  'vat.payHelp': 'Le numéro de compte et le KID sont fournis par Skatteetaten une fois la déclaration traitée. Le paiement direct depuis la banque n\'est pas encore connecté ; le paiement est donc enregistré dans Plumme pour le moment.',
  'vat.awaitingAuthority': 'Fourni par Skatteetaten',
  'vat.pay': 'Payer',
  'vat.kidHelp': 'KID de la MVA-melding',
  'vat.authorityAccount': 'Numéro de compte de Skatteetaten',
  'vat.authorityAccountHelp': 'Le numéro de compte de Skatteetaten',
  'vat.notRegistered': 'L\'entreprise n\'est pas paramétrée comme assujettie à la TVA',
  'vat.view': 'Affichage',
  'vat.viewHelp': 'Basculez entre « Périodes » — une carte par période de TVA avec statut et échéance — et « Vue d\'ensemble », qui résume ce que vous devez, avez payé et avez à récupérer sur l\'ensemble des périodes.',
  'vat.viewTerms': 'Périodes',
  'vat.viewOverview': 'Vue d\'ensemble',
  'vat.filing.notFiled': 'Non déposée',
  'vat.filing.upcomingStatus': 'À venir',
  'vat.filing.importedArchive': 'Archive importée',
  'vat.vatReceivable': 'Crédit de TVA',
  'vat.vatToPay': 'TVA à payer',
  'vat.noVat': 'Pas de TVA',
  'vat.receivableShort': 'À récupérer',
  'vat.remainingToPay': 'Reste à payer',
  'vat.termLabel': 'Période {n} {year}',
  'vat.noTermsHelp': 'Une fois l\'entreprise assujettie à la TVA, Plumme affiche ici les périodes, les échéances et la TVA calculée.',
  'vat.youOwe': 'Vous devez',
  'vat.youAreOwed': 'Vous avez à récupérer',
  'vat.noVatToSettle': 'Aucune TVA à régler',
  'vat.refund': 'Remboursement',
  'vat.paymentNoun': 'Paiement',
  'vat.settlementNoun': 'Règlement',
  'vat.acctBankDeposit': 'Dépôts bancaires',
  'vat.acctTaxDeductionAccount': 'Compte de retenue fiscale',
  'vat.acctCash': 'Caisse',
  'vat.accountFallback': 'Compte {code}',
  'vat.settlementFullyRegistered': 'Entièrement enregistré',
  'vat.settlementPartiallyRegistered': 'Partiellement enregistré',
  'vat.settlementNotRegistered': 'Non enregistré',
  'vat.editRefund': 'Modifier le remboursement',
  'vat.editPayment': 'Modifier le paiement',
  'vat.receivedOn': 'Reçu sur',
  'vat.paidFrom': 'Payé depuis',
  'vat.noPaymentsHelp': 'Lorsque vous enregistrez un paiement ou un remboursement pour la période, il s\'affiche ici.',
  'vat.addRefund': 'Ajouter un remboursement',
  'vat.addPayment': 'Ajouter un paiement',
  'vat.cancelPaymentConfirmPrefix': 'Voulez-vous annuler le {kind} de',
  'vat.cancelPaymentConfirmDate': ' enregistré le {date}',
  'vat.cancelPaymentConfirmSuffix': ' ? Le montant sera retiré de la période de TVA et ne pourra pas être récupéré.',
  'vat.overpaid': 'Trop payé',
  'vat.overrefunded': 'Trop remboursé',
  'vat.remainingToReceive': 'Reste à recevoir',
  'vat.registerSettlement': 'Enregistrer le règlement',
  'vat.registerPayment': 'Enregistrer le paiement',
  'vat.registerRefund': 'Enregistrer le remboursement',
  'vat.inYourFavor': 'en votre faveur',
  'vat.toTaxAuthority': 'à Skatteetaten',
  'vat.receivedBack': 'Remboursé',
  'vat.archiveCannotSettle': 'L\'historique importé ne peut pas être réglé comme une nouvelle période Plumme.',
  'vat.noVatToSettleForTerm': 'La période ne comporte aucune TVA à régler.',
  'vat.sourceImported': 'Importé',
  'vat.sourceManual': 'Enregistré manuellement',
  'vat.registerVatRefund': 'Enregistrer un remboursement de TVA',
  'vat.registerVatPayment': 'Enregistrer un paiement de TVA',
  'vat.saveRefund': 'Enregistrer le remboursement',
  'vat.savePayment': 'Enregistrer le paiement',
  'vat.remainingHint': 'Reste {amount}',
  'vat.notRegisteredHelp': 'Une fois l\'entreprise paramétrée comme assujettie à la TVA, Plumme affiche ici les périodes de TVA, la vue par code et le règlement.',
  'vat.reviewReadyToast': 'La MVA-melding est prête à être vérifiée',
  'vat.customsAltinnNotConnected': 'L\'import Altinn des déclarations en douane n\'est pas encore connecté.',
  'vat.selectAttachmentToUpload': 'Choisissez une pièce jointe à téléverser',
  'vat.customsDefaultDescription': 'Déclaration en douane',
  'vat.customsDateTermHint': 'La date doit être comprise dans {period}.',
  'vat.customs81': '25 % avec droit à déduction',
  'vat.customs82': '25 % sans droit à déduction',
  'vat.customs83': '15 % avec droit à déduction',
  'vat.customs84': '15 % sans droit à déduction',
  'vat.customs85': '0 % importation',
  'vat.customsSaved': 'Déclaration en douane enregistrée',
  'vat.customsSaveFailed': 'Impossible d\'enregistrer la déclaration en douane.',
  'vat.customsDeleted': 'Déclaration en douane supprimée',
  'vat.customsDeleteFailed': 'Impossible de supprimer la déclaration en douane.',
  'vat.refundSaved': 'Remboursement enregistré',
  'vat.paymentSaved': 'Paiement enregistré',
  'vat.paymentSaveFailed': 'Impossible d\'enregistrer le paiement.',
  'vat.refundCancelled': 'Remboursement annulé',
  'vat.paymentCancelled': 'Paiement annulé',
  'vat.paymentCancelFailed': 'Impossible d\'annuler le paiement.',
  'vat.supplierSearch': 'Rechercher ou ajouter un fournisseur...',
  'vat.supplierClose': 'Fermer la sélection du fournisseur',
  'vat.supplierNone': 'Aucun fournisseur trouvé.',
  'vat.supplierNew': 'Nouveau fournisseur',
  'vat.supplierName': 'Nom',
  'vat.supplierOrg': 'N° d\'org.',
  'vat.supplierEmail': 'E-mail',
  'vat.supplierPhone': 'Téléphone',
  'vat.customsPostingExplanation': 'Utilisez les montants de la déclaration en douane. La TVA non déductible doit être comptabilisée sur le compte de charges ou d\'actif approprié.',
  'vat.nonDeductibleAccount': 'Compte pour la TVA non déductible',
  'vat.nonDeductibleAccountHelp': 'Choisissez le même compte de charges ou d\'actif que celui de l\'acquisition. Un compte doit être indiqué avant la comptabilisation.',
  'voucherList.titleHelp': 'Un justificatif est la documentation qui sous-tend une écriture : facture, reçu, autre vente, déclaration en douane ou écriture libre. Vous voyez ici les justificatifs récupérés depuis le backend pour l\'exercice sélectionné.',
  'voucherList.backToTrialBalance': 'Retour à la balance générale',
  'voucherList.backToIncomeStatement': 'Retour au compte de résultat',
  'voucherList.accountBadge': 'Compte {number} · {name}',
  'voucherList.vatCodeBadge': 'Code TVA {code}',
  'voucherList.viewOptions': 'Options d\'affichage',
  'voucherList.noneForVatCode': 'Aucun justificatif trouvé pour le code TVA {code} sur la période sélectionnée.',
  'voucherList.noneForAccount': 'Aucun justificatif comptabilisé sur {number} {name} en {year}.',
  'voucherList.noneMatchSearch': 'Aucun justificatif ne correspond à la recherche.',
  'voucherList.noneInView': 'Aucun justificatif ne correspond à cet affichage.',
  'voucherList.ledgerLinesMissing': 'Les justificatifs n\'ont pas de lignes d\'écriture provenant du backend.',
  'voucherList.debit': 'Débit',
  'voucherList.credit': 'Crédit',
  'voucherList.colVoucher': 'Justificatif',
  'voucherList.colNumber': 'N° de justificatif',
  'voucherList.colDate': 'Date',
  'voucherList.inlineVat': 'TVA',
  'voucherList.kindInvoice': 'Facture',
  'voucherList.kindSupplier': 'Fournisseur',
  'voucherList.kindCreditNote': 'Avoir',
  'voucherList.kindManual': 'Justificatif manuel',
  'voucherList.kindPurchase': 'Achat',
  'voucherList.kindOtherSale': 'Autre vente',
  'voucherList.kindMileage': 'Journal de bord kilométrique',
  'voucherList.kindCustoms': 'Déclaration en douane',
  'voucherList.kindCustomsCorrection': 'Correction de période de la déclaration en douane',
  'voucherList.kindBankPosting': 'Écriture bancaire',
  'voucherList.kindPayment': 'Paiement',
  'voucherList.kindPayroll': 'Paie',
  'voucherList.kindPayrollPayment': 'Versement de la paie',
  'voucherList.kindReversal': 'Contrepassation',
  'voucherList.kindPublicFees': 'Taxes et redevances publiques',
  'voucherList.kindAssetDisposal': 'Sortie d\'immobilisation',
  'voucherList.kindYearEnd': 'Clôture annuelle',
  'voucherList.kindQuote': 'Devis',
  'voucherList.kindOrderConfirmation': 'Confirmation de commande',
  'voucherList.filterSales': 'Ventes',
  'voucherList.filterSupplierInvoice': 'Facture fournisseur',
  'voucherList.filterFreePosting': 'Écriture libre',
  'voucherList.missingAttachment': 'Pièce jointe manquante',
  'voucherList.hasAttachment': 'Avec pièce jointe',
  'voucherList.unpaid': 'Impayé',
  'voucherList.showAnnulled': 'Afficher les annulés',
  'voucherList.hidePayments': 'Masquer les paiements',
  'voucherList.includeAnnulled': 'Inclure les annulés',
  'vat.amountOnly': 'TVA seule',
  'voucherList.onlyAnnulled': 'Afficher uniquement les annulés',
  'voucherList.paid': 'Payé',
  'voucherList.partiallyPaid': 'Partiellement payé',
  'voucherList.annulled': 'Annulé',
  'voucherList.attachmentLost': 'Justificatif perdu',
  'voucherList.openInvoiceList': 'Voir dans la liste des factures',
  'voucherList.editSale': 'Modifier la vente',
  'voucherList.openInBank': 'Ouvrir dans Banque',
  'voucherList.editPosting': 'Modifier l\'écriture',
  'voucherList.correctPosting': 'Corriger le justificatif',
  'voucherList.editMileage': 'Modifier le journal de bord kilométrique',
  'voucherList.openInVat': 'Ouvrir dans TVA',
  'voucherList.edit': 'Modifier',
  'voucherList.purchaseNotFound': 'Impossible de trouver l\'achat à modifier. Actualisez la page et rouvrez le justificatif.',
  'voucherList.saleNotFound': 'Impossible de trouver la vente à modifier. Actualisez la page et rouvrez le justificatif.',
  'inboxStatus.alreadyBooked': 'Déjà comptabilisé ?',
  'inboxStatus.booked': 'Comptabilisé',
  'inboxStatus.inTrash': 'Dans la corbeille',
  'inboxStatus.readyToBook': 'Prêt à comptabiliser',
  'inboxStatus.needsReview': 'À vérifier',
  'inboxStatus.analysisFailed': 'Échec de l\'analyse',
  'inboxStatus.analyzing': 'Analyse en cours',
  'inboxStatus.awaitingAnalysis': 'En attente d\'analyse',
  'inboxStatus.show': 'Afficher',
  'inboxStatus.hide': 'Masquer',
  'inboxStatus.dropReceipts': 'Déposez les justificatifs ici',
  'inboxStatus.dropReceiptsHint': 'SuperPlumma lit ce qu’il peut',
  'inboxStatus.dropDocuments': 'Déposez les documents ici',
  'inboxStatus.dropDocumentsHint': 'Ajoutés à Documentation',
  'inboxStatus.bookWithSuperPlumma': 'Comptabiliser avec SuperPlumma',
  'inboxStatus.saving': 'Enregistrement...',
  'purchaseFlow.stepReceipt': 'Justificatif',
  'purchaseFlow.stepDetails': 'Détails',
  'purchaseFlow.stepLines': 'Lignes',
  'purchaseFlow.stepPreview': 'Aperçu',
  'purchaseFlow.typeRegular': 'Achat payé',
  'purchaseFlow.typeInvoice': 'Facture fournisseur',
  'purchaseFlow.typeDrafts': 'Brouillons',
  'purchaseFlow.receivedReading': 'Justificatif reçu - SuperPlumma le lit maintenant',
  'purchaseFlow.receivedReadingMany': '{count} justificatifs reçus - SuperPlumma les lit maintenant',
  'purchaseFlow.prefilled': 'SuperPlumma a rempli ce qui pouvait être lu sur le justificatif. Vérifiez avant de comptabiliser.',
  'purchaseFlow.amountReview': 'Les montants et la TVA n’ont pas pu être remplis de façon fiable. Vérifiez le justificatif et saisissez le montant HT et le bon traitement de TVA pour chaque ligne avant de comptabiliser.',
  'purchaseFlow.analysisFailed': 'Le justificatif a été importé, mais l’analyse a échoué.',
  'purchaseFlow.inboxResolveFailed': 'L’écriture est enregistrée, mais le justificatif n’a pas été retiré de la boîte de réception. Marquez-le comme comptabilisé à cet endroit.',
  'purchaseFlow.receiptFallbackName': 'Justificatif',
});
